/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Artist_LabelInputs */

const en_field_artist_label = /** @type {(inputs: Field_Artist_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artist / Label`)
};

const es_field_artist_label = /** @type {(inputs: Field_Artist_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artista / Sello`)
};

const fr_field_artist_label = /** @type {(inputs: Field_Artist_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artiste / Label`)
};

const de_field_artist_label = /** @type {(inputs: Field_Artist_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Künstler / Label`)
};

const ja_field_artist_label = /** @type {(inputs: Field_Artist_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アーティスト / レーベル`)
};

const zh_field_artist_label = /** @type {(inputs: Field_Artist_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`艺术家 / 厂牌`)
};

const ar_field_artist_label = /** @type {(inputs: Field_Artist_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفنان / شركة الإنتاج`)
};

const id_field_artist_label = /** @type {(inputs: Field_Artist_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artis / Label`)
};

const it_field_artist_label = /** @type {(inputs: Field_Artist_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artista / Etichetta`)
};

const ru_field_artist_label = /** @type {(inputs: Field_Artist_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Артист / Лейбл`)
};

const pt_field_artist_label = /** @type {(inputs: Field_Artist_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artista / Selo`)
};

const ko_field_artist_label = /** @type {(inputs: Field_Artist_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아티스트 / 레이블`)
};

/**
* | output |
* | --- |
* | "Artist / Label" |
*
* @param {Field_Artist_LabelInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_artist_label = /** @type {((inputs?: Field_Artist_LabelInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Artist_LabelInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_artist_label(inputs)
	if (locale === "es") return es_field_artist_label(inputs)
	if (locale === "fr") return fr_field_artist_label(inputs)
	if (locale === "de") return de_field_artist_label(inputs)
	if (locale === "ja") return ja_field_artist_label(inputs)
	if (locale === "zh") return zh_field_artist_label(inputs)
	if (locale === "ar") return ar_field_artist_label(inputs)
	if (locale === "id") return id_field_artist_label(inputs)
	if (locale === "it") return it_field_artist_label(inputs)
	if (locale === "ru") return ru_field_artist_label(inputs)
	if (locale === "pt") return pt_field_artist_label(inputs)
	return ko_field_artist_label(inputs)
});